import styled from 'styled-components'

export const FooterBox = styled.div`
  gap: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
`
